'use client'
import Script from 'next/script'

const MetaPixiel = () => (
  <Script
    id='facebook-pixel'
    strategy='afterInteractive'
    // biome-ignore lint/security/noDangerouslySetInnerHtml: This is a trusted script from Facebook for tracking page views.
    dangerouslySetInnerHTML={{
      __html: `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1745863883464318');
      fbq('track', 'PageView');
      `
    }}
  />
)

const MetaPixielNoScript = () => (
  <noscript>
    <img
      height='1'
      width='1'
      alt='Facebook Pixel'
      style={{ display: 'none' }}
      src='https://www.facebook.com/tr?id=1745863883464318&ev=PageView&noscript=1'
    />
  </noscript>
)

export { MetaPixielNoScript }
export default MetaPixiel
